import React,{ useEffect, useState } from 'react';
import { db } from "./firebase";
import './Orders.css'
import { useStateValue } from './StateProvider';
import { collection, doc, onSnapshot, orderBy, query } from "firebase/firestore";
import Order from './Order';


function Orders() {
  const [{ basket, user }, dispatch] = useStateValue();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (user) {
      const ordersRef = collection(doc(collection(db, "users"), user?.uid), "orders");
      const q = query(ordersRef, orderBy("created", "desc"));

      const offSnapshot = onSnapshot(q, (snapshot) => {
        setOrders(snapshot.docs.map(doc => ({
          id: doc.id,
          data: doc.data(),
        })));
      });

      return () => offSnapshot();
    }
  }, [user]);



  return (
    <div className='orders'>
      <h1>Your Orders</h1>

      <div className='orders__order'>
        {orders?.map(order => (
          <Order order={order} />
        ))}
      </div>
    </div>
  )
}

export default Orders
